import { render, staticRenderFns } from "./base.vue?vue&type=template&id=4dd5d990&scoped=true"
import script from "./base.vue?vue&type=script&lang=js"
export * from "./base.vue?vue&type=script&lang=js"
import style0 from "./base.vue?vue&type=style&index=0&id=4dd5d990&prod&lang=scss&scoped=true"
import style1 from "./base.vue?vue&type=style&index=1&id=4dd5d990&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd5d990",
  null
  
)

export default component.exports